import SubcollectionContent from "./subcollection-content.jsx";
import { h, render } from "preact";

class SectionSubcollection extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.mainCollection = this.querySelector("[data-main-collection]");
    this.init();
  }

  init() {
    const MainCollection = () => {
      return <SubcollectionContent data={this.data} />;
    };

    render(<MainCollection />, this.mainCollection);
  }
}

if (!customElements.get("section-subcollection")) {
  customElements.define("section-subcollection", SectionSubcollection);
}
